module.exports = __webpack_public_path__ + "static/img/logo.1c1dbb25.png";